import { isQA } from '~src/lib/environment';

/*
 * QA points at Command's QA env; prod, staging, and everything else point at
 * production Command. Unlike legacy Hub, retailers should not be doing real
 * work in our staging environment, so staging users are intentionally sent to
 * prod Command rather than a staging-specific target.
 */
export default () =>
  isQA() ? 'https://command.narvar.qa/' : 'https://command.narvar.com/';
